import { Button } from "../../../components/ui/Button";
import { looks } from "../data/looks";
import { Look } from "../data/types";

interface LooksCarrouselProps {
  selectedLook: Look;
  onLookSelect: (look: Look) => void;
  onLookDetails: () => void;
}

export const LooksCarrousel = ({
  selectedLook,
  onLookSelect,
  onLookDetails,
}: LooksCarrouselProps) => {
  return (
    <div className="flex flex-col gap-4 items-center w-full">
      <div className="flex flex-col items-center w-full">
        <p className="text-white text-center font-garamond-italic text-base font-normal leading-tight">
          Looks à la Louboutin
        </p>
        <h1 className="text-white text-center font-bebas-kai text-[32px] font-normal leading-tight">
          {selectedLook.title}
        </h1>
      </div>
      <Button onClick={onLookDetails}>
        <p className="px-4">View look</p>
      </Button>
      <div className="flex p-4 rounded-[2px] bg-[rgba(5,5,5,0.20)] backdrop-blur-xl w-full">
        <div className="flex overflow-x-auto gap-4 w-full justify-evenly">
          {looks.map((look) => (
            <div
              key={look.id}
              className="flex flex-col gap-1 items-center cursor-pointer flex-shrink-0"
              onClick={() => onLookSelect(look)}
            >
              <img
                src={look.imagePath}
                alt={look.imagePath}
                className={`w-[80px] h-[112px] object-cover ${
                  look.id === selectedLook.id ? "border-2 border-[#CE0A2C]" : ""
                }`}
              />
              <p
                className={`text-center font-bebas-kai text-xs font-normal ${
                  look.id === selectedLook.id ? "text-[#CE0A2C]" : "text-white"
                }`}
              >
                {look.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
